"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOptionsModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const dialog_1 = require("primereact/dialog");
const button_1 = require("primereact/button");
const SortOptionsModal = ({ visible, onHide, sortField, sortOrder, handleSortChange, options = [], }) => {
    const applySort = (field) => {
        const newOrder = sortField === field && sortOrder === 1 ? -1 : 1;
        handleSortChange(field, newOrder);
        //onHide()
    };
    return ((0, jsx_runtime_1.jsxs)(dialog_1.Dialog, { visible: visible, onHide: onHide, position: "bottom", dismissableMask: true, showHeader: false, className: "w-full sm:w-96 rounded-t-2xl m-0", contentStyle: {
            borderTopLeftRadius: '2rem',
            borderTopRightRadius: '2rem',
            paddingBottom: '1rem',
        }, children: [(0, jsx_runtime_1.jsx)("div", { className: "w-12 h-1 bg-gray-300 rounded-full mx-auto mb-4 mt-4" }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col divide-y gap-2 rounded-t-2xl", children: options.map((opt) => ((0, jsx_runtime_1.jsx)(button_1.Button, { label: opt.label, icon: sortField === opt.field
                        ? sortOrder === 1
                            ? 'pi pi-sort-amount-up'
                            : 'pi pi-sort-amount-down'
                        : 'pi pi-sort-alt', className: `w-full text-left p-2 ${sortField === opt.field ? 'p-button-info' : 'p-button-text'}`, onClick: () => applySort(opt.field) }, opt.field))) })] }));
};
exports.SortOptionsModal = SortOptionsModal;
